import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
    titlePage: {
        fontSize: 20,
        fontWeight: 600,
        color: '#2B56A5',
        textAlign: "center",
        borderBottom: '1px solid',
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
        },
    },
    textArea: {
        width: '100%',
        height: '7vh',
        margin: '0 auto',
        border: 'none',
        borderBottom: '1px dashed #aaa'
    },
    border: {
        border: '1px solid',
    },
    content: {
        width: '90%',
        margin: '0 auto',
    },
    actived: {
        width: '100%',
        display: 'flex',
        justifyContent: "center",
        alignItems: "center",
        alignContent: 'center',
        cursor: 'pointer'
    },
    contentArray: {
        borderBottom: '1px solid',
    },
    colorGreen: {
        color: 'white',
        backgroundColor: '#5fc194',
        padding: '1.5vh 0',
    }
}));
